// import React from "react";
// import ReactDOM from "react-dom/client";
// import "./index.css";
// import "@fontsource/inter";
// import LandingPage from "./LandingPage";
// import {
//   FingerprintJSPro,
//   FpjsProvider,
// } from "@fingerprintjs/fingerprintjs-pro-react";
//Pratham
// const root = ReactDOM.createRoot(
//   document.getElementById("root") as HTMLElement
// );
// root.render(
//   <React.StrictMode>
//     <FpjsProvider
//       loadOptions={{
//         apiKey: "LAQ3MT1FHparLBFLpNdg",
//         endpoint: [
//           "https://metrics.app20.in",
//           FingerprintJSPro.defaultEndpoint,
//         ],
//         scriptUrlPattern: [
//           "https://metrics.app20.in/web/v<version>/<apiKey>/loader_v<loaderVersion>.js",
//           FingerprintJSPro.defaultScriptUrlPattern,
//         ],
//         // region: "ap",
//       }}
//     >
//       <LandingPage />
//     </FpjsProvider>
//   </React.StrictMode>
// );

import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "@fontsource/inter";
import LandingPage from "./pages/public/LandingPage";
// import PaymentHistoryPage from "./pages/dashboard/PaymentHistoryPage";
/* import {
  FpjsProvider,
} from "@fingerprintjs/fingerprintjs-pro-react"; */
import { HelmetProvider, Helmet } from 'react-helmet-async';

import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Provider } from "react-redux";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import { store } from "./store/store";
import { queryClient } from "./lib/queryClient";

import OnboardPage from "./pages/public/OnboardPage";
import TaskSubmissionPage from "./pages/public/TaskSubmissionPage";
import TaskSubmissionPageFB from "./pages/public/TaskSubmissionPageFB";
import TaskSubmissionPageAds from "./pages/public/TaskSubmissionPageAds";
import SubmissionRejectedPageAds from "./pages/public/SubmissionRejectedPageAds";
// import HelpPage from "./pages/public/HelpPage";
// import TermsAndConditionsPage from "./pages/public/TermsAndConditionsPage";
// import PrivacyPolicyPage from "./pages/public/PrivacyPolicyPage";
// import ContactUsPage from "./pages/public/ContactUsPage";
import DeleteAccountPage from "./pages/public/DeleteAccountPage";
// import FacebookRedirect from "./pages/public/FacebookRedirect";
import PaymentProcessingPage from "./pages/status/PaymentProcessingPage";
import PaymentProcessingPageFb from "./pages/status/PaymentProcessingPageFb";
import PaymentProcessingPageAds from "./pages/status/PaymentProcessingPageAds";
import PaymentProcessingPageReject from "./pages/status/PaymentProcessingPageReject";
import PaymentSuccessPage from "./pages/status/PaymentSuccessPage";
import PaymentSuccessPageAds from "./pages/status/PaymentSuccessPageAds";
import PaymentSuccessPageFb from "./pages/status/PaymentSuccessPageFb";
import PaymentSuccessPageReject from "./pages/status/PaymentSuccessPageReject";
/* import LoginPage from "./pages/auth/LoginPage";
import OtpPage from "./pages/auth/OtpPage";
import OffersFeedPage from "./pages/dashboard/OffersFeedPage";
import InstallOfferPage from "./pages/dashboard/InstallOfferPage";
import ProfilePage from "./pages/dashboard/ProfilePage"; */
import QRGenerator from "./components/QRGenerator";
import GTMTracker from "./components/GTMTracker";
import MetaPixelTrackerAds from "./components/MetaPixelTrackerAds";
import MetaPixelTrackerFB from "./components/MetaPixelTrackerFB";
import DesktopBlocker from "./components/common/DesktopBlocker";
// import ProtectedRoute from "./components/auth/ProtectedRoute";

import IntercomManager from "./components/common/IntercomManager";
import VersionChecker from "./components/common/VersionChecker";
import ErrorBoundary from "./components/common/ErrorBoundary";
import NotFoundPage from "./pages/public/NotFoundPage";
import DownloadPage from "./pages/public/DownloadPage";
import RedditLandingPage from "./pages/public/RedditLandingPage";


if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then(regs => {
    regs.forEach(r => r.unregister());
  });
}
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ErrorBoundary>
        <IntercomManager />
        <HelmetProvider>
          <QueryClientProvider client={queryClient}>
            {/* <FpjsProvider
              loadOptions={{
                apiKey: "LAQ3MT1FHparLBFLpNdg",
              }}
            > */}
            <BrowserRouter>
              <VersionChecker />
              <GTMTracker />
              <MetaPixelTrackerAds />
              <MetaPixelTrackerFB />
              <Helmet>
                <meta name="robots" content="noindex, nofollow" />
              </Helmet>
              <DesktopBlocker />
              <Routes>
                <Route path="/1" element={<DownloadPage />} />
                <Route path="/submit-task" element={<TaskSubmissionPage />} />
                <Route path="/submit-task-fb" element={<TaskSubmissionPageFB />} />
                <Route path="/submit-task-ads" element={<TaskSubmissionPageAds />} />
                <Route path="/reject" element={<SubmissionRejectedPageAds />} />
                <Route path="/payment-processing" element={<PaymentProcessingPage />} />
                <Route path="/payment-processing-fb" element={<PaymentProcessingPageFb />} />
                <Route path="/payment-processing-ads" element={<PaymentProcessingPageAds />} />
                <Route path="/payment-processing-reject" element={<PaymentProcessingPageReject />} />
                <Route path="/payment-success" element={<PaymentSuccessPage />} />
                <Route path="/payment-success-ads" element={<PaymentSuccessPageAds />} />
                <Route path="/payment-success-fb" element={<PaymentSuccessPageFb />} />
                <Route path="/payment-success-reject" element={<PaymentSuccessPageReject />} />
                {/* <Route path="/login" element={<LoginPage />} />
                  <Route path="/otp-verify" element={<OtpPage />} /> */}

                {/* Protected Routes */}
                {/* <Route element={<ProtectedRoute />}>
                    <Route path="/dashboard" element={<OffersFeedPage />} />
                    <Route path="/offer-install/*" element={<InstallOfferPage />} />
                    <Route path="/profile" element={<ProfilePage />} />
                    <Route path="/payment-history" element={<PaymentHistoryPage />} />
                  </Route> */}

                <Route path="/onboard" element={<OnboardPage />} />
                {/* <Route path="/help" element={<HelpPage />} />
                <Route path="/terms-and-conditions" element={<TermsAndConditionsPage />} />
                <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                <Route path="/contact-us" element={<ContactUsPage />} /> */}
                <Route path="/delete-account" element={<DeleteAccountPage />} />
                <Route path="/qr-generator" element={<QRGenerator />} />
                <Route path="/reddit" element={<RedditLandingPage />} />
                <Route path="/fb" element={<LandingPage />} />
                <Route path="/ads" element={<LandingPage />} />
                <Route path="/" element={<LandingPage />} />
                {/* Catch-all route must be last */}
                <Route path="/*" element={<NotFoundPage />} />
              </Routes>
            </BrowserRouter>
            {/* </FpjsProvider> */}
            {/* React Query Devtools - only in development */}
            {process.env.NODE_ENV === "development" && (
              <ReactQueryDevtools initialIsOpen={false} />
            )}
          </QueryClientProvider>
        </HelmetProvider>
      </ErrorBoundary>
    </Provider>
  </React.StrictMode>
);
